import { useGetOrderByIdQuery } from "@sso/apis/order/order";
import ItemTotals from "@sso/components/Payment/ItemTotals";
import LineItems from "@sso/components/Payment/LineItems";
import { DialogTitle } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { Flex } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

import { DialogBody, DialogHeader } from "../components";

const OrderDetailsDialog = () => {
  const { id } = useAppSelector(selectDialog);
  if (!id) {
    throw new Error("OrderDetails: id is null");
  }

  const { data, isSuccess } = useGetOrderByIdQuery(id);

  return (
    <>
      {" "}
      <DialogHeader title={DialogTitle.DETAILS_ORDER} />
      <DialogBody>
        {data && isSuccess && (
          <>
            <Flex gap="1rem" direction="column" align="flex-start" margin="0 0 .5rem 0">
              <Typography>
                User : {data.user.firstname} {data.user.lastname}{" "}
              </Typography>
              <Typography>Created : {new Date(data.createdDate).toLocaleDateString()} </Typography>
              <div>
                <LineItems currency={data.transactionCurrency} items={data.lineItems}></LineItems>
                <ItemTotals order={data} />
              </div>
            </Flex>
          </>
        )}
      </DialogBody>
    </>
  );
};

export default OrderDetailsDialog;
